import { store } from "@/main";

import * as setting_types from "@/store/constants/setting_types";

import Vue from "vue";

const contactUs = async (transactionId?: string, offerId?: string) => {
  try {
    const recipients: string =
      store.getters[setting_types.GETTER_CONTACT_EMAIL];

    Vue.prototype.$_Dialog.show({
      title: "Contact Us",
      content: {
        text: `You can contact us by email: <%${recipients}/%>, If you need support with an order, don't forget to mention your Instagram username and your order number.`,
        highlightColor: "rgb(79, 121, 255)"
      },
      closable: true,
      closeOnClickModal: true,
      onConfirm(done: any) {
        done();
      }
    });
  } catch (error) {
    //
  }
};
export default contactUs;
